export * from "./feature-flag.service";



// WEBPACK FOOTER //
// ./src/app/shared/services/feature-flag/index.ts